<template>
<div class="modal fade" id="session-local-form-modal" data-bs-backdrop="static" tabindex="-1" aria-labelledby="erkModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-lg">
        <div class="modal-content">
            <div class="modal-header py-2 pe-2">
                <strong class="modal-title">
                    MODIFICA ATTIVITÀ
                </strong>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div v-if="isLoading">

                </div>
                <form v-else>
                    <MbInputErrors 
                        :errors="errors"
                        name="form">
                    </MbInputErrors>

                    <div class="row g-lg-3 mb-3">
                        <div class="col-sm-3">
                            <label for="limite_giornaliero" class="col-form-label">Titolo</label>
                        </div>
                        <div class="col">
                            <input type="text" v-model="form.title" class="form-control" maxlength="255">
                            <div class="invalid-feedback">Specificare un valore</div>
                            <MbInputErrors 
                                :errors="errors"
                                name="title">
                            </MbInputErrors>
                        </div>
                    </div>
                    
                    <div class="row g-lg-3 mb-3">
                        <div class="col-sm-3">
                            <label for="date" class="col-form-label">Data *</label>
                        </div>
                        <div class="col">
                            <input type="date" v-model="form.date" name="date" value="" class="form-control" required="">
                            <div class="invalid-feedback">Specificare un periodo</div>
                        </div>
                        <MbInputErrors 
                            :errors="errors"
                            name="date">
                        </MbInputErrors>
                    </div>
                    <div class="row g-lg-3 mb-3">
                        <div class="col-sm-3">
                            <label for="time1" class="col-form-label">Dalle *</label>
                        </div>
                        <div class="col">
                            <input type="time" v-model="form.fromHour" name="time1" value="" class="form-control" required="">
                            <div class="invalid-feedback">Specificare orario inizio</div>

                            <MbInputErrors 
                                :errors="errors"
                                name="fromHour">
                            </MbInputErrors>
                        </div>
                        <div class="col-sm-3">
                            <label for="time2" class="col-form-label">Alle *</label>
                        </div>
                        <div class="col">
                            <input type="time" v-model="form.toHour" name="time2" value="" class="form-control" required="">
                            <div class="invalid-feedback">Specificare orario fine</div>
                            <MbInputErrors 
                                :errors="errors"
                                name="toHour">
                            </MbInputErrors>
                        </div>
                    </div>
                    <div class="row g-lg-3 mb-3">
                        <div class="col-sm-3">
                            <label for="note" class="col-form-label">Note</label>
                        </div>
                        <div class="col">
                            <textarea name="note" v-model="form.note" class="form-control" placeholder=""></textarea>
                            <div class="invalid-feedback">Specificare una data</div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary close-btn" 
                    v-if="!isLoading"
                    @click="onClickSave()">
                    <span class="bi-check2-circle"></span>
                    Salva e assegna esercizi
                </button>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import MbInputErrors from "@/components/ui/base/MbInputErrors"

export default{
    components: {
        MbInputErrors
    },
    props: {
        userId: Number,
        value: Object
    },
    data(){
        return {
            sessionId: null,
            isLoading: true,
            errors: {},
            form: {
            }
        }
    },
    mounted(){
    },
    methods: {
        loadSessionData(sessionId){
            this.sessionId = sessionId
            this.isLoading = true
            let url = this.buildActionUrl("session", true)
            if (sessionId){
                url += "&sessionId=" + sessionId
            }

            axios.get(url)
                .then((response) => {
                    this.isLoading = false

                    if (response.hasErrors){
                        return
                    }

                    this.form = response.data.result
                    this.toggle()
                })
                .catch((error) => {
                    this.isLoading = false
                    alert(error)
                })
        },
        buildActionUrl(method, api){
            if (!method){
                method = "_default"
            }

            let actionUrl = "/structure/student/session/SessionDetailsAction-" + method + "?sessionId=" + this.sessionId  + "&userId=" + this.userId

            if (api){
                actionUrl += "&outFormat=json"
            }

            return actionUrl
        },
        toggle(){
            let myModal = new window.bootstrap.Modal(document.getElementById('session-local-form-modal'))
            myModal.toggle()
        },
        onClickSave(){
            let _this = this

            axios.post(this.buildActionUrl("edit", true), this.form)
                .then((response) => {
                    if (!response.data.success){
                        let errors = response.data.result
                        errors['form'] = response.data.errors

                        _this.$set(_this, "errors", errors)
                        return
                    }

                    window.location = this.buildActionUrl()
                })
                .catch((error) => {
                    _this.$set(_this.errors, "form", [error])
                })
        }
    }
}

</script>